<template>
  <tr @click="agentDetails" class="cursor-pointer px-0">
    <td
      class="truncate-cell px-0"
      style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
    >
      <v-avatar color="primary" size="36" class="my-3 mr-2">
        <span class="text-white text-h6">{{ avatar }}</span>
      </v-avatar>
      {{ agentDisplayName }}
    </td>
    <td class="text-right">
      <span>{{ agentScore }}</span>
    </td>
    <td class="text-right">
      <span>
        {{ closings }}
      </span>
    </td>
    <td class="text-right">
      <span>
        {{ revenue }}
      </span>
    </td>
    <td class="text-right pr-0">
      <span>
        {{ responseTime }}
      </span>
    </td>
  </tr>
</template>

<script>
import useAuthMixin from "@/mixins/auth";
import useFormatters from "@/mixins/formatters";

export default {
  name: "console-overview-agent-leaderboard-row",
  props: {
    agent: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {},
  computed: {
    avatar() {
      return this.agent?.name && this.agent?.name !== ""
        ? this.agent.name.charAt(0).toUpperCase()
        : "-";
    },
    agentDisplayName() {
      return this.agent?.name && this.agent?.name !== ""
        ? this.agent.name
        : "Not Available";
    },
    agentScore() {
      if (this.agent && this.agent.agentDisplayScore) {
        let perc = this.agent.agentDisplayScore * 100;
        if (perc > 0 && perc < 1) {
          return `${parseFloat(perc).toFixed(2)}`;
        } else {
          return `${parseFloat(perc).toFixed(0)}`;
        }
      }

      return "-";
    },
    closings() {
      return this.agent?.closings ? this.agent.closings : "0";
    },
    revenue() {
      return this.agent?.revenue
        ? this.formatCurrency(this.agent.revenue, 0)
        : "$0";
    },
    responseTime() {
      if (!this.agent?.last7ResponseTime && !this.agent?.last30ResponseTime) {
        return "No invitations in the last 30 days.";
      }

      let last7 = "*";
      let last30 = "*";

      if (this.agent?.last7ResponseTime) {
        last7 = `${this.formatTimeDurationString(
          this.agent.last7ResponseTime,
          true,
        )}`;
      }

      if (this.agent?.last30ResponseTime) {
        last30 = `${this.formatTimeDurationString(
          this.agent.last30ResponseTime,
          true,
        )}`;
      }

      return `${last7} / ${last30}`;
    },
  },
  data() {
    return {};
  },
  methods: {
    ...useAuthMixin(),
    ...useFormatters(),
    agentDetails() {
      console.log("Clicked on agent:");
      console.log(this.agent.agentId);
      this.$emit("viewAgent", this.agent.agentId);
    },
  },
};
</script>

<style scoped>
.truncate-cell {
  max-width: 1px;
}

.agent-display-name {
  height: unset;
}
</style>
